import React from 'react';
import { ToastContainer } from 'react-toastify';
import classnames from 'classnames';

import {
  TOAST_CONTAINER_IDS, TOAST_POSITIONS,
  fadeTransition, slideFadeTransition
} from 'common/Toast';
import { FeatureOnboardingModal } from 'components/onboarding';
import { useLayoutStore } from 'context/LayoutContext';
import { useNotificationsStore } from 'context/NotificationsContext';

import styles from './ToastContainers.module.scss';

const ToastContainers = () => {
  return (
    <div data-testid="common.toast-container">

      {/* Generic */}
      <GenericToastContainer />

      {/* Custom */}
      <CustomToastContainer />

      {/* Banners */}
      <BannerToastContainer />

    </div>
  );
};

// Generic Toast Container

const GenericToastContainer = () => {
  const { isOpenInAppBannerVisible } = useLayoutStore();
  return (
    <ToastContainer
      className={classnames(
        styles.container,
        styles.generic,
        { [styles.offset]: isOpenInAppBannerVisible }
      )}
      toastClassName={classnames(styles.toast, styles.genericToast)}
      //
      containerId={TOAST_CONTAINER_IDS.GENERIC}
      position={TOAST_POSITIONS.BottomRight}
      //
      autoClose={3000}
      draggable={false}
      hideProgressBar
      icon={false}
      theme="dark"
      transition={fadeTransition}
    />
  );
};

// Custom Toast Container

const CustomToastContainer = () => {
  const { customToastContainerProps } = useNotificationsStore();
  const { className, ...restContainerProps } = customToastContainerProps || {};
  return (
    <ToastContainer
      className={classnames(styles.container, styles.custom, className?.toString())}
      toastClassName={classnames(styles.toast, styles.customToast)}
      //
      containerId={TOAST_CONTAINER_IDS.CUSTOM}
      position={TOAST_POSITIONS.BottomRight}
      //
      autoClose={3000}
      hideProgressBar
      draggable={false}
      icon={false}
      theme="dark"
      //
      {...restContainerProps}
    />
  );
};

// Banner Toast Container

const BannerToastContainer = () => {
  return (
    <ToastContainer
      //
      className={classnames(styles.container, styles.banners)}
      toastClassName={styles.bannerToast}
      // bodyClassName={styles.bannerToastBody}
      //
      containerId={TOAST_CONTAINER_IDS.BANNERS}
      position={TOAST_POSITIONS.BottomRight}
      //
      autoClose={false}
      closeButton={false}
      closeOnClick={false}
      draggable={false}
      hideProgressBar
      //
      limit={1}
      transition={slideFadeTransition}
      //
    />
  );
};

// Export

export default ToastContainers;
